module.exports = __webpack_public_path__ + "static/img/theme_list_icon02.2b3cd1fa.svg";